import React, { useEffect, useRef, useState, useCallback } from "react";
import styled, { keyframes } from "styled-components";
import { media } from "../Utils/media";
import bgImage from "../Assets/Images/testbg1.jpg";
import testbg2 from "../Assets/Images/testbg2.png";
import slide1 from "../Assets/Images/slide1.jpg";
import slide2 from "../Assets/Images/slide2.jpg";
import slide3 from "../Assets/Images/slide3.jpg";
import lastBG from "../Assets/Images/lastBG.png";
import performanceBG from "../Assets/Images/performanceBG.png";
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import useCountOnView from "../Components/useCountOnView";
import { fluidFont } from "../Utils/fontSize";

const Home = () => {
  const slideData = [
    {
      num: "01",
      txt: "기존 서류를 전자 문서로 전환",
      desc: "어디서나 작업할 수 있는 전자문서로 DX 전환을 선도",
      img: slide1,
    },
    {
      num: "02",
      txt: "AI가 검증하는 HR 문서",
      desc: "인적 오류를 줄이고 업무 부담을 감소",
      img: slide2,
    },
    {
      num: "03",
      txt: "블록체인을 통한 강력한 보안",
      desc: "위변조의 리스크를 원천 차단",
      img: slide3,
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);
  const timeoutRef = useRef(null);
  const isSyncingRef = useRef(false);
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  const startAutoSlide = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      if (swiperRef.current) {
        const nextIndex = (swiperRef.current.realIndex + 1) % slideData.length;
        swiperRef.current.slideToLoop(nextIndex);
      }
    }, 4000);
  }, [slideData.length]);

  const onListItemClick = (index) => {
    if (!swiperRef.current) return;
    isSyncingRef.current = true;
    swiperRef.current.slideToLoop(index);
    setActiveIndex(index);

    startAutoSlide();

    setTimeout(() => {
      isSyncingRef.current = false;
    }, 400);
  };

  const onSlideChange = (swiper) => {
    if (isSyncingRef.current) return;
    setActiveIndex(swiper.realIndex);
    startAutoSlide();
  };

  useEffect(() => {
    startAutoSlide();
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [startAutoSlide]);

  useEffect(() => {
    const timer = setInterval(() => {
      if (swiperRef.current) {
        const nextIndex = (swiperRef.current.realIndex + 1) % slideData.length;
        swiperRef.current.slideToLoop(nextIndex);
      }
    }, 4000);
    return () => clearInterval(timer);
  }, [slideData.length]);

  useEffect(() => {
    AOS.init({});
  }, []);

  const [count1, ref1] = useCountOnView(9999, 1000);
  const [count2, ref2] = useCountOnView(500, 1000);
  const [count3, ref3] = useCountOnView(1000, 1000);
  const [count4, ref4] = useCountOnView(200, 1000);

  return (
    <PageContainer>
      <SectionContainer>
        <MainCopyArea>
          <Header2Copy data-aos="fade-up" data-aos-delay="100" data-aos-duration="1400">
            위대한 꿈을 이루는 선구자, 지디피 스튜디오가 나아갈 길입니다.
          </Header2Copy>
          <Header1Copy style={{ marginTop: "24px" }} data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
            G<StrokeText>enerative</StrokeText> D<StrokeText>ocument</StrokeText> P<StrokeText>rocessing</StrokeText>
          </Header1Copy>
          <Header3Copy style={{ marginTop: "24px" }} data-aos="fade-up" data-aos-delay="300" data-aos-duration="1400">
            DID 기반 경력증명서 발급 솔루션을 통해 경력 증명의 새로운 장을 펼치겠습니다.
          </Header3Copy>
        </MainCopyArea>
      </SectionContainer>
      <SectionArea style={{ boxSizing: "border-box", backgroundColor: "#000000", flexDirection: "column" }}>
        <Title1CopyWrapper>
          <div style={{ textAlign: "center", marginBottom: "80px" }}>
            <Title1Copy data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
              <StrokeText>Our</StrokeText> Services
            </Title1Copy>
          </div>
        </Title1CopyWrapper>
        <ServiceListArea data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
          <ServiceListItem>
            <div style={{ display: "flex", alignItems: "flex-start" }}>
              <ServiceItemNumCopy>01</ServiceItemNumCopy>
              <div style={{ display: "flex", alignItems: "flex-start", flexDirection: "column" }}>
                <ServiceItemCategoryCopy>E-Career Certificate Platform</ServiceItemCategoryCopy>
                <ServiceItemTitleCopy>전자 경력증명서 발급 플랫폼</ServiceItemTitleCopy>
              </div>
            </div>
            <ServiceItemTitleWrapper>
              <ServiceItemDescriptionCopy>
                앱에서 요청하고 관리하는
                {!isMobile && <br />}
                전자 경력증명서
              </ServiceItemDescriptionCopy>
            </ServiceItemTitleWrapper>
          </ServiceListItem>
          <ServiceListItem style={{ borderTop: "none" }}>
            <div style={{ display: "flex", alignItems: "flex-start" }}>
              <ServiceItemNumCopy>02</ServiceItemNumCopy>
              <div style={{ display: "flex", alignItems: "flex-start", flexDirection: "column" }}>
                <ServiceItemCategoryCopy>Human resource Contract Management SaaS</ServiceItemCategoryCopy>
                <ServiceItemTitleCopy>HR 계약 관리 SaaS</ServiceItemTitleCopy>
              </div>
            </div>
            <ServiceItemTitleWrapper>
              <ServiceItemDescriptionCopy>
                중소기업을 위한
                {!isMobile && <br />}
                직원과의 계약 관리 솔루션
              </ServiceItemDescriptionCopy>
            </ServiceItemTitleWrapper>
          </ServiceListItem>
          <ServiceListItem style={{ borderTop: "none" }}>
            <div style={{ display: "flex", alignItems: "flex-start" }}>
              <ServiceItemNumCopy>03</ServiceItemNumCopy>
              <div style={{ display: "flex", alignItems: "flex-start", flexDirection: "column" }}>
                <ServiceItemCategoryCopy>AI Based Eligibility Screening SaaS</ServiceItemCategoryCopy>
                <ServiceItemTitleCopy>AI 기반 적격심사 자동화 SaaS</ServiceItemTitleCopy>
              </div>
            </div>
            <ServiceItemTitleWrapper>
              <ServiceItemDescriptionCopy>
                블록체인 기반 Doc2Action 기반
                {!isMobile && <br />}
                기업용 LLM Agent 시스템
              </ServiceItemDescriptionCopy>
            </ServiceItemTitleWrapper>
          </ServiceListItem>
        </ServiceListArea>
      </SectionArea>
      <Section3Container>
        <Title1CopyWrapper>
          <div style={{ textAlign: "center", marginBottom: "80px" }}>
            <Title1Copy2 data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
              커지는 이직 시장에서 스마트한 서류 관리를 통해 업무를 줄여줍니다.
            </Title1Copy2>
            <Title1Copy3 data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
              <StrokeText>지디피 스튜디오는</StrokeText> HR을 가장 깊이 이해하고
              {!isMobile && <br />}
              활용하는 <StrokeText>HR 서류 관리 전문 기업입니다.</StrokeText>
            </Title1Copy3>
          </div>
        </Title1CopyWrapper>
        <Wrapper data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
          <List>
            {slideData.map((item, index) => (
              <ListItem key={index} active={index === activeIndex} onClick={() => onListItemClick(index)}>
                <ServiceItemNumCopy>{item.num}</ServiceItemNumCopy>
                <SwiperItemTitleCopy>{item.txt}</SwiperItemTitleCopy>
              </ListItem>
            ))}
          </List>
          <RightSwiperWrapper>
            <Swiper
              modules={[Autoplay]}
              slidesPerView={1}
              loop
              onSwiper={(swiper) => {
                swiperRef.current = swiper;
              }}
              onSlideChange={onSlideChange}
              spaceBetween={30}
            >
              {slideData.map((item, idx) => (
                <SwiperSlide key={idx}>
                  <SlideInner bg={item.img}>
                    <TxtWrap>
                      <TxtNum>{item.num}</TxtNum>
                      <div>
                        <TxtTit>{item.txt}</TxtTit>
                        <TxtBody>{item.desc}</TxtBody>
                      </div>
                    </TxtWrap>
                  </SlideInner>
                </SwiperSlide>
              ))}
            </Swiper>
          </RightSwiperWrapper>
        </Wrapper>
      </Section3Container>
      <PerformanceArea>
        <PerformanceContainer>
          <PerformanceTitleCopy data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
            성과 지표
          </PerformanceTitleCopy>
          <PerformanceItemArea>
            <PerformanceItem data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
              <img src={require("../Assets/Images/performanceIcon1.png")} alt="performanceIcon1" width={isMobile ? "52px" : "80px"} height="auto" />
              <PerformanceItemTitleCopy>총 콘텐츠 발행 수</PerformanceItemTitleCopy>
              <PerformanceItemBodyCopy ref={ref1}>{count1}개</PerformanceItemBodyCopy>
            </PerformanceItem>
            <PerformanceItem data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
              <img src={require("../Assets/Images/performanceIcon2.png")} alt="performanceIcon2" width={isMobile ? "52px" : "80px"} height="auto" />
              <PerformanceItemTitleCopy>총 콘텐츠 발행 수</PerformanceItemTitleCopy>
              <PerformanceItemBodyCopy ref={ref2}>{count2}개</PerformanceItemBodyCopy>
            </PerformanceItem>
            <PerformanceItem data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
              <img src={require("../Assets/Images/performanceIcon3.png")} alt="performanceIcon3" width={isMobile ? "52px" : "80px"} height="auto" />
              <PerformanceItemTitleCopy>총 콘텐츠 발행 수</PerformanceItemTitleCopy>
              <PerformanceItemBodyCopy ref={ref3}>{count3}개</PerformanceItemBodyCopy>
            </PerformanceItem>
            <PerformanceItem data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
              <img src={require("../Assets/Images/performanceIcon4.png")} alt="performanceIcon4" width={isMobile ? "52px" : "80px"} height="auto" />
              <PerformanceItemTitleCopy>총 콘텐츠 발행 수</PerformanceItemTitleCopy>
              <PerformanceItemBodyCopy ref={ref4}>{count4}개</PerformanceItemBodyCopy>
            </PerformanceItem>
          </PerformanceItemArea>
        </PerformanceContainer>
      </PerformanceArea>
      <FieldPerformanceContainer>
        <Title1CopyWrapper>
          <div style={{ textAlign: "center", marginBottom: "80px" }}>
            <Title1Copy
              data-aos="fade-up"
              data-aos-delay="200"
              data-aos-duration="1400"
              style={{ marginBottom: isMobile ? "50px" : "100px", lineHeight: "135%" }}
            >
              업종은 달랐지만, 모두 콘텐츠 퍼포먼스로
              <br />
              <StrokeText>증명된 성과를 경험했습니다.</StrokeText>
            </Title1Copy>
          </div>
        </Title1CopyWrapper>
        <FieldPerformanceItemArea data-aos="fade-up" data-aos-delay="400" data-aos-duration="1400">
          <FieldPerformanceItem>
            <FieldPerformanceMark>의료/헬스케어 업종</FieldPerformanceMark>
            <FieldPerformanceImage>
              <img src={require("../Assets/Images/healthTest.jpg")} alt="healthTest" width={"100%"} />
            </FieldPerformanceImage>
            <FieldPerformanceText>
              <FieldPerformanceTextCopy>
                콘텐츠 도달률 평균 2,000뷰 이상 달성
                <br />→ 단기 계약에도 조회수, 예약 문의 증가 확인
              </FieldPerformanceTextCopy>
              <FieldPerformanceTag>
                <FieldPerformanceTagCopy>미니쉬치과병원</FieldPerformanceTagCopy>
                <FieldPerformanceTagCopy>생활건강한의원</FieldPerformanceTagCopy>
                <FieldPerformanceTagCopy>아비쥬의원</FieldPerformanceTagCopy>
                <FieldPerformanceTagCopy>서울오브치과</FieldPerformanceTagCopy>
              </FieldPerformanceTag>
            </FieldPerformanceText>
          </FieldPerformanceItem>
          <FieldPerformanceItem>
            <FieldPerformanceMark>의료/헬스케어 업종</FieldPerformanceMark>
            <FieldPerformanceImage>
              <img src={require("../Assets/Images/brandTest.jpg")} alt="brandTest" width={"100%"} />
            </FieldPerformanceImage>
            <FieldPerformanceText>
              <FieldPerformanceTextCopy>브랜드 검색량 상승 및 DM 유입 증가 확인</FieldPerformanceTextCopy>
              <FieldPerformanceTag>
                <FieldPerformanceTagCopy>CJ 올리브네트웍스</FieldPerformanceTagCopy>
                <FieldPerformanceTagCopy>정해담</FieldPerformanceTagCopy>
                <FieldPerformanceTagCopy>발란스플로우</FieldPerformanceTagCopy>
                <FieldPerformanceTagCopy>장생길</FieldPerformanceTagCopy>
              </FieldPerformanceTag>
            </FieldPerformanceText>
          </FieldPerformanceItem>
        </FieldPerformanceItemArea>
      </FieldPerformanceContainer>
      <LastContainer>
        <LastArea>
          <LastTitleContainer data-aos="fade-up" data-aos-delay="200" data-aos-duration="1400">
            <LastTitleCopy>
              특별한 기획 방식과 독창적인 콘텐츠로
              <br />
              <StrokeText>당신의 내일을 오늘 만듭니다.</StrokeText>
            </LastTitleCopy>
          </LastTitleContainer>
          <LastCircleArea data-aos="fade-up" data-aos-delay="400" data-aos-duration="1400">
            <LastCircleItem>
              <LastCircleImage>
                <img src={require("../Assets/Images/circleTest1.png")} alt="circleTest1" width={"100%"} />
              </LastCircleImage>
              <LastCircleTextArea>
                <LastCircleTitleCopy>기획력</LastCircleTitleCopy>
                <LastCircleBodyCopy>전략적 사고와 창의적 접근</LastCircleBodyCopy>
              </LastCircleTextArea>
            </LastCircleItem>
            <LastCircleItem>
              <LastCircleImage>
                <img src={require("../Assets/Images/circleTest2.png")} alt="circleTest2" width={"100%"} />
              </LastCircleImage>
              <LastCircleTextArea>
                <LastCircleTitleCopy>전환력</LastCircleTitleCopy>
                <LastCircleBodyCopy>결과를 만드는 실행 역량</LastCircleBodyCopy>
              </LastCircleTextArea>
            </LastCircleItem>
            <LastCircleItem>
              <LastCircleImage>
                <img src={require("../Assets/Images/circleTest3.png")} alt="circleTest3" width={"100%"} />
              </LastCircleImage>
              <LastCircleTextArea>
                <LastCircleTitleCopy>미래력</LastCircleTitleCopy>
                <LastCircleBodyCopy>지속가능한 성장 동력</LastCircleBodyCopy>
              </LastCircleTextArea>
            </LastCircleItem>
          </LastCircleArea>
        </LastArea>
      </LastContainer>
    </PageContainer>
  );
};

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  background-color: #000000;
  overflow: hidden;
  width: 100%;
`;

const SectionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  overflow: hidden;
  width: 100%;
  height: 100vh;
  background: url(${bgImage}) no-repeat center / cover;
  ${media.web`
    min-height: 800px;
  `}

  ${media.mobile`
    min-height: 700px;
  `}
`;

const MainCopyArea = styled.div`
  width: 100%;
  max-width: 1470px;
  padding: 0 20px;
  margin: 0 auto;
`;

const Header1Copy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "GongGothicMedium";
  font-style: normal;
  word-break: keep-all;
  font-weight: 500;
  ${media.web`
    font-size: 80px;
  `}
  ${media.mobile`
    font-size: 36px;
    line-height:1.35;
  `}
`;

const Header2Copy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  word-break: keep-all;
  font-weight: 700;
  ${media.web`
    font-size: ${fluidFont(24, 36)};
  `}
  ${media.mobile`
    font-size: 16px;
  `}
`;

const Header3Copy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  word-break: keep-all;
  font-weight: 700;
  ${media.web`
    font-size: 24px;
  `}

  ${media.mobile`
    font-size: 16px;
    line-height:1.5;
  `}
`;

const SectionArea = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  background: url(${testbg2}) no-repeat right top 5% / 60%;
  ${media.mobile`
  padding:0 20px;
  `}
`;

const Section3Container = styled.div`
  width: 100%;
  box-sizing: border-box;
  background-color: #000000;
  padding: 0 20px;
`;

const Title1CopyWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  max-width: 1470px;
  padding: 0 20px;
  margin: 0 auto;
`;

const Title1Copy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  word-break: keep-all;
  font-weight: 800;
  ${media.web`
    font-size: ${fluidFont(32, 54)};
  `}
  ${media.mobile`
    font-size: 32px;
  `}
`;

const Title1Copy2 = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  word-break: keep-all;
  margin-bottom: 20px;
  font-weight: 700;
  ${media.web`
    font-size: ${fluidFont(16, 24)};
  `}
  ${media.mobile`
    margin-top:125px;
    font-size: 20px;
  `}
`;

const Title1Copy3 = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  word-break: keep-all;
  margin-bottom: 20px;
  font-weight: 800;
  ${media.web`
    font-size: ${fluidFont(32, 54)};
    line-height:1.5;
  `}

  ${media.mobile`
    font-size: 24px;
    line-height:1.35;
  `}
`;

const ServiceListArea = styled.div`
  width: 100%;
  max-width: 1470px;
  margin: 0 auto;
  box-sizing: border-box;
  ${media.web`
    padding: 0 20px 200px;
  `}
`;

const ServiceListItem = styled.div`
  display: flex;
  justify-content: space-between;
  border-top: solid 1px #aaaaaa;
  border-bottom: solid 1px #aaaaaa;
  width: 100%;
  gap: 16px 20px;
  position: relative;
  ${media.web`
    align-items: center;
    flex-direction: row;
    gap: 16px 20px;
    padding: 55px 0;
  `}

  ${media.mobile`
    flex-direction: column;
    padding: 24px 0;
  `}
`;

const ServiceItemNumCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  word-break: keep-all;
  width: 70px;
  font-weight: 700;
  ${media.web`
    font-size: 18px;
  `}
  ${media.mobile`
    font-size: 14px;
  `}
`;

const ServiceItemCategoryCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  word-break: keep-all;
  font-weight: 600;
  ${media.web`
    font-size: 16px;
  `}
  ${media.mobile`
    font-size: 14px;
  `}
`;

const ServiceItemTitleCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  word-break: keep-all;
  font-weight: 700;
  margin-top: 16px;
  ${media.web`
    font-size: ${fluidFont(20, 34)};
  `}

  ${media.mobile`
    font-size: 24px;
  `}
`;

const ServiceItemTitleWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  ${media.mobile`
  margin-left:70px;
  `}
`;

const ServiceItemDescriptionCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  word-break: keep-all;
  font-weight: 600;
  ${media.web`
    font-size: ${fluidFont(16, 24)};
    line-height:1.35;
    text-align:right;
  `}
  ${media.mobile`
    font-size: 16px;
    line-height:1.5;
  `}
`;

const SwiperItemTitleCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  ${media.web`
    font-size:  ${fluidFont(14, 28)};
    margin-top:30px;
  `}
  ${media.mobile`
    font-size: 20px;
    margin-top:16px;
  `}
`;

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 1470px;
  margin: 0 auto;
  ${media.web`
    flex-direction: row;
  `}
  ${media.mobile`
    flex-direction: column;
  `}
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${media.web`
    margin-right: 4vw;
  `}
`;

const ListItem = styled.div`
  border-bottom: 1px solid #fff;
  opacity: ${(props) => (props.active ? 1 : 0.5)};
  transition: opacity 0.5s ease;
  cursor: pointer;
  ${media.web`
  padding: 30px 0;
  min-width:210px;
  `}
  ${media.mobile`
  padding: 24px 0;
  `}
`;

const RightSwiperWrapper = styled.div`
  height: 456px;
  ${media.web`
  width:60%
    /* max-width: 858px; */
  `}
  ${media.mobile`
    width: 100%;
    margin:24px 0 80px;
  `}
  .swiper-slide {
    display: flex;
    align-items: flex-end;
    position: relative;
    box-sizing: border-box;
  }
`;

const SlideInner = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  max-width: 858px;
  height: 456px;
  background: url(${(props) => props.bg}) center center / cover no-repeat;
  background-size: cover;
  position: relative;
  border-radius: 16px;
`;

const TxtWrap = styled.div`
  font-family: "Pretendard";
  font-style: normal;
  padding: 30px;
  color: white;
  .num {
    font-weight: bold;
    font-size: 18px;
    display: block;
    margin-bottom: 8px;
  }
  .tit {
    font-size: 28px;
    font-weight: 800;
    display: block;
  }
  p {
    margin-top: 10px;
    font-size: 16px;
    line-height: 1.4;
  }
`;

const TxtNum = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 800;
  margin-bottom: 8px;
  ${media.web`
  font-size: 18px;
  `}
  ${media.mobile`
  font-size: 14px;
  `}
`;

const TxtTit = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 800;
  margin-bottom: 8px;
  ${media.web`
  font-size: 28px;
  `}
  ${media.mobile`
  font-size: 18px;
  `}
`;

const TxtBody = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 500;
  ${media.web`
  font-size: 20px;
  `}
  ${media.mobile`
  font-size: 14px;
  `}
`;

const PerformanceArea = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
  width: 100%;
  background: url(${performanceBG}) no-repeat center top 87% / 100%;
  ${media.web`
  height: 100vh;
  margin-top:250px;
  `}
  ${media.mobile`
  height: 80vh;
  margin-top:50px;
  `}
`;

const PerformanceContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 1470px;
  ${media.web`
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;
  padding:0 20px;
  `}
  ${media.mobile`
  flex-direction: column;
  padding:0 20px;
  `}
`;

const PerformanceTitleCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 800;
  ${media.web`
  font-size: ${fluidFont(32, 54)};
  `}
  ${media.mobile`
  font-size: 24px;
  margin-bottom:50px;
  `}
`;

const PerformanceItemArea = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
`;

const PerformanceItem = styled.div`
  display: flex;
  flex-direction: column;
  border: solid 1px rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  background: linear-gradient(140deg, rgba(84, 79, 79, 0.1), rgba(84, 79, 79, 0.05));
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  transition: all 0.2s;
  ${media.web`
width:32vw;
max-width:440px;
  height:320px;
  border-radius: 20px;
  padding: 30px 40px 40px 30px;
  `}
  ${media.mobile`
  width:100%;
  border-radius: 8px;
  padding: 8px 16px 16px 8px;
  `}
  &:hover {
    background: linear-gradient(140deg, rgba(61, 167, 255, 0.4), rgba(61, 167, 255, 0.08));
  }
`;

const PerformanceItemTitleCopy = styled.div`
  color: #3da7ff;
  font-family: "Pretendard";
  font-style: normal;
  position: relative;
  z-index: 2;
  text-align: right;
  font-weight: 700;
  margin-top: 40px;
  ${media.web`
  font-size: 20px;
  `}
  ${media.mobile`
  font-size: 16px;
  `}
`;

const PerformanceItemBodyCopy = styled.div`
  color: rgb(255, 255, 255);
  font-family: "Pretendard";
  font-style: normal;
  position: relative;
  z-index: 2;
  text-align: right;
  font-weight: 700;
  ${media.web`
  font-size: ${fluidFont(32, 58)};
  margin-top:24px;
  `}
  ${media.mobile`
  font-size: 28px;
  margin-top:8px;
  `}
`;

const FieldPerformanceContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1470px;
  ${media.web`
  padding:0 20px;
  `}
  ${media.mobile`
  width: 100%;
  align-items:center;
  `}
`;

const FieldPerformanceItemArea = styled.div`
  display: flex;
  ${media.web`
  gap: 35px 40px;
  `}
  ${media.mobile`
  flex-direction: column;
  max-width: 400px;
  gap: 35px 20px;
  `}
`;

const FieldPerformanceItem = styled.div`
  position: relative;
  background: linear-gradient(135deg, rgba(224, 219, 219, 0.3), rgba(249, 249, 249, 0.03));
  ${media.web`
  border-radius: 20px;
  `}
  ${media.mobile`
  border-radius: 8px;
  `}
  &:hover {
    background: linear-gradient(140deg, rgba(61, 167, 255, 0.4), rgba(61, 167, 255, 0.08));
  }
`;

const FieldPerformanceMark = styled.div`
  display: flex;
  align-items: center;
  background: #3da7ff;
  position: absolute;
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  color: #ffffff;
  border-radius: 50px;
  top: 0;
  transform: translateY(-50%);
  ${media.web`
  font-size: 22px;
  padding: 12px 24px;
  left: 36px;
  `}
  ${media.mobile`
  font-size: 16px;
  padding: 8px 16px;
  left: 16px;
  `}
`;

const FieldPerformanceImage = styled.div`
  overflow: hidden;
  ${media.web`
    border-radius: 20px 20px 0 0;
  `}
  ${media.mobile`
    border-radius: 8px 8px 0 0;
  `}
`;

const FieldPerformanceText = styled.div`
  box-sizing: border-box;
  ${media.web`
  padding: 40px 34px;
  `}
  ${media.mobile`
  padding: 16px;
  `}
`;

const FieldPerformanceTextCopy = styled.div`
  color: #ffffff;
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  line-height: 1.4;
  border-bottom: solid 1px rgba(255, 255, 255, 0.25);
  ${media.web`
  font-size: ${fluidFont(16, 32)};
  padding-bottom: 24px;
  margin-bottom: 20px;
  `}
  ${media.mobile`
  font-size: 20px;
  padding-bottom: 16px;
  margin-bottom: 16px;
  `}
`;

const FieldPerformanceTag = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;

const FieldPerformanceTagCopy = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  border: solid 1px rgba(255, 255, 255, 0.25);
  font-weight: 700;
  border-radius: 40px;
  ${media.web`
  font-size: ${fluidFont(14, 18)};
  padding: 12px 24px;
  `};
  ${media.mobile`
  font-size: 14px;
  padding: 8px 12px;
  `};
`;

const LastContainer = styled.div`
  background: url(${lastBG}) no-repeat right top / 45%;
  width: 100%;
  ${media.web`
  padding: 200px 0;
  `}
  ${media.mobile`
  padding: 100px 0;
  `}
`;

const LastArea = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 1470px;
  padding: 0 20px;
  margin: 0 auto;
`;

const LastTitleContainer = styled.div`
  text-align: center;
  ${media.web`
  margin-bottom: 80px;
  `}
`;

const LastTitleCopy = styled.div`
  color: #ffffff;
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 800;
  line-height: 1.35;
  ${media.web`
  font-size: ${fluidFont(32, 54)};
  `}
  ${media.mobile`
  font-size: 24px;
  margin-bottom:50px;
  `}
`;

const LastCircleArea = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  ${media.mobile`
  flex-direction: column;
  max-width: 300px;
  margin: 0 auto;
  `}
`;

const LastCircleItem = styled.div`
  position: relative;
`;

const rotate = keyframes`
from {
  transform: rotate(0deg);
}
to {
  transform: rotate(360deg);
}
`;

const LastCircleImage = styled.div`
  animation: ${rotate} 10s infinite linear;
`;

const LastCircleTextArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  text-align: center;
  gap: 20px;
  width: 100%;
  height: 100%;
  top: 0%;
  left: 0;
`;

const LastCircleTitleCopy = styled.div`
  color: #ffffff;
  font-family: "Pretendard";
  font-style: normal;
  word-break: keep-all;
  font-weight: 700;
  line-height: 1.4;
  ${media.web`
    font-size: ${fluidFont(16, 34)};
  `}
  ${media.mobile`
    font-size: 24px;
  `}
`;

const LastCircleBodyCopy = styled.div`
  color: #ffffff;
  font-family: "Pretendard";
  font-style: normal;
  word-break: keep-all;
  margin: 0;
  padding: 0;
  line-height: 1.5;
  ${media.web`
    font-size: ${fluidFont(12, 18)};
    font-weight: 700;
  `}
  ${media.mobile`
    font-size: 16px;
    font-weight: 500;
  `}
`;

const StrokeText = styled.span`
  -webkit-text-stroke: 1px #ffffff;
  color: transparent !important;
`;

export default Home;
